
/**
 * It is used to map parameters while update the rush flag status based on manual action
 * on RUSH checkbox
 * @author Sumit Singh Karki
 */

export class RushFlagUpdateRequest {
    genomicsOrderRef: string;
    orderStatus: string;
    isRush: boolean;
}